/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const listProducts = /* GraphQL */ `query ListProducts($dummy: String) {
  listProducts(dummy: $dummy) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductsQueryVariables,
  APITypes.ListProductsQuery
>;
export const validateRoleArn = /* GraphQL */ `query ValidateRoleArn($roleArn: String) {
  validateRoleArn(roleArn: $roleArn) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ValidateRoleArnQueryVariables,
  APITypes.ValidateRoleArnQuery
>;
export const getEc2Price = /* GraphQL */ `query GetEc2Price($instanceType: String!, $region: String!) {
  getEc2Price(instanceType: $instanceType, region: $region) {
    instanceType
    region
    price
    location
    instanceFamily
    vCPU
    memory
    storage
    networkPerformance
    operatingSystem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEc2PriceQueryVariables,
  APITypes.GetEc2PriceQuery
>;
export const listEc2Prices = /* GraphQL */ `query ListEc2Prices(
  $instanceType: String
  $region: ModelStringKeyConditionInput
  $filter: ModelEc2PriceFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEc2Prices(
    instanceType: $instanceType
    region: $region
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      instanceType
      region
      price
      location
      instanceFamily
      vCPU
      memory
      storage
      networkPerformance
      operatingSystem
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEc2PricesQueryVariables,
  APITypes.ListEc2PricesQuery
>;
export const getUserInfo = /* GraphQL */ `query GetUserInfo($userId: String!) {
  getUserInfo(userId: $userId) {
    userId
    accounts {
      items {
        accountId
        monitorRoleArn
        accountName
        refreshRule
        createdAt
        updatedAt
        userInfoAccountsUserId
        owner
        __typename
      }
      nextToken
      __typename
    }
    userName
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserInfoQueryVariables,
  APITypes.GetUserInfoQuery
>;
export const listUserInfos = /* GraphQL */ `query ListUserInfos(
  $userId: String
  $filter: ModelUserInfoFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUserInfos(
    userId: $userId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      userId
      accounts {
        nextToken
        __typename
      }
      userName
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserInfosQueryVariables,
  APITypes.ListUserInfosQuery
>;
export const getAccountInfo = /* GraphQL */ `query GetAccountInfo($accountId: String!) {
  getAccountInfo(accountId: $accountId) {
    accountId
    monitorRoleArn
    accountName
    refreshRule
    createdAt
    updatedAt
    userInfoAccountsUserId
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountInfoQueryVariables,
  APITypes.GetAccountInfoQuery
>;
export const listAccountInfos = /* GraphQL */ `query ListAccountInfos(
  $accountId: String
  $filter: ModelAccountInfoFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAccountInfos(
    accountId: $accountId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      accountId
      monitorRoleArn
      accountName
      refreshRule
      createdAt
      updatedAt
      userInfoAccountsUserId
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountInfosQueryVariables,
  APITypes.ListAccountInfosQuery
>;
export const getAccountQuota = /* GraphQL */ `query GetAccountQuota($accountId: String!) {
  getAccountQuota(accountId: $accountId) {
    accountId
    scanQuota
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountQuotaQueryVariables,
  APITypes.GetAccountQuotaQuery
>;
export const listAccountQuotas = /* GraphQL */ `query ListAccountQuotas(
  $accountId: String
  $filter: ModelAccountQuotaFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAccountQuotas(
    accountId: $accountId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      accountId
      scanQuota
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountQuotasQueryVariables,
  APITypes.ListAccountQuotasQuery
>;
export const getAccountPayments = /* GraphQL */ `query GetAccountPayments($accountId: String!, $orderId: String!) {
  getAccountPayments(accountId: $accountId, orderId: $orderId) {
    accountId
    orderId
    productId
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountPaymentsQueryVariables,
  APITypes.GetAccountPaymentsQuery
>;
export const listAccountPayments = /* GraphQL */ `query ListAccountPayments(
  $accountId: String
  $orderId: ModelStringKeyConditionInput
  $filter: ModelAccountPaymentsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAccountPayments(
    accountId: $accountId
    orderId: $orderId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      accountId
      orderId
      productId
      status
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountPaymentsQueryVariables,
  APITypes.ListAccountPaymentsQuery
>;
export const getAccountToResource = /* GraphQL */ `query GetAccountToResource($accountId: String!, $resourceId: String!) {
  getAccountToResource(accountId: $accountId, resourceId: $resourceId) {
    accountId
    resourceId
    resourceRegion
    resourceStatus
    resourceType
    resourceCreatedAt
    resourcePriceType
    tags
    index
    summary {
      resourceType
      status
      scannedCount
      idleCount
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountToResourceQueryVariables,
  APITypes.GetAccountToResourceQuery
>;
export const listAccountToResources = /* GraphQL */ `query ListAccountToResources(
  $accountId: String
  $resourceId: ModelStringKeyConditionInput
  $filter: ModelAccountToResourceFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAccountToResources(
    accountId: $accountId
    resourceId: $resourceId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      accountId
      resourceId
      resourceRegion
      resourceStatus
      resourceType
      resourceCreatedAt
      resourcePriceType
      tags
      index
      summary {
        resourceType
        status
        scannedCount
        idleCount
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountToResourcesQueryVariables,
  APITypes.ListAccountToResourcesQuery
>;
